<script>
import axios from 'axios'
import $ from 'jquery'
import TheSearchModal from './modal/TheSearchModal.vue'

export default {
  components: { TheSearchModal },
  props: {
    triggerRecherche: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      searchToken: '',
      showModal: false
    }
  },
  methods: {
    openModal: function () {
      if (this.searchToken.length > (this.triggerRecherche-1)) {
        this.showModal = true
      }
    },
    closeModal: function () {
      this.showModal = false
      let header = $('header')
      if (header.hasClass('mobileView')) {
        $('#block_recherche .recherche').removeClass('selected')
        if (!header.hasClass('visibleSearch')) {
          $('#block_recherche input[data-drupal-selector=edit-query]').animate({ width: 'hide' }).blur()
        }
        this.searchToken = ''
      }
    }
  }
}
</script>
